import type { Directive, DirectiveBinding } from 'vue'

import { useAuthStore } from '../stores/auth'

import { canWith, type AclAction } from './can'

export { ALWAYS, canWith, type AclAction } from './can'

/** `can()` against the current session (KIT_REQUIREMENTS.md §2: hide-only gates). */
export function can(resource: string, action: AclAction = 'read'): boolean {
  return canWith(useAuthStore().session, resource, action)
}

export type CanBinding = string | { resource: string; action?: AclAction }

function allowed(binding: DirectiveBinding<CanBinding>): boolean {
  const value = binding.value
  if (typeof value === 'string') return can(value, binding.arg === 'write' ? 'write' : 'read')
  return can(value.resource, value.action ?? 'read')
}

function apply(el: HTMLElement, binding: DirectiveBinding<CanBinding>): void {
  el.style.display = allowed(binding) ? '' : 'none'
}

/**
 * `v-can="'employees'"`, `v-can:write="'employees'"` or `v-can="{ resource: 'employees', action: 'write' }"`.
 * Hides the element when the user lacks the permission — legacy hid, never disabled (wp/shell §1).
 */
export const vCan: Directive<HTMLElement, CanBinding> = {
  mounted: apply,
  updated: apply,
}
